// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__13iO6","info":"PatientInfo_info__225B-"};